import React, { useEffect } from "react";
import { McPagination } from "@maersk-global/mds-react-wrapper/components-core/mc-pagination";
import { McSelect } from "@maersk-global/mds-react-wrapper/components-core/mc-select";
import { McOption } from "@maersk-global/mds-react-wrapper/components-core/mc-option";

interface PaginationControlProps {
  totalItems: number;
  narrowPagination?: boolean;
  currentPage: number;
  pageSize: number;
  pageSizeOptions: number[];
  position?: "center" | "right" | "left";
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

const PaginationControl: React.FC<PaginationControlProps> = ({
  totalItems,
  narrowPagination = false,
  currentPage,
  pageSize,
  pageSizeOptions,
  position = "right",
  onPageChange,
  onPageSizeChange,
}) => {
  useEffect(() => {
    if (!pageSizeOptions.includes(pageSize)) {
      onPageSizeChange(pageSizeOptions[0]);
    }
  }, [pageSize, pageSizeOptions, onPageSizeChange]);

  const calPostion = (position: string) => {
    switch (position) {
      case "center":
        return "center";
      case "right":
        return "flex-end";
      case "left":
        return "flex-start";
      default:
        return "flex-end";
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: calPostion(position),
        alignItems: "center",
        marginTop: "10px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
        <McSelect
          label=""
          labelposition="left"
          value={pageSize.toString()}
          optionselected={(e: any) => {
            const value = e.detail?.[0]?.value ?? e.detail?.value;
            const newSize = parseInt(String(value), 10);
            if (!isNaN(newSize) && newSize > 0) {
              onPageSizeChange(newSize);
            }
          }}
          placeholder=""
          style={{ width: "100px" }}
        >
          {pageSizeOptions.map((size) => (
            <McOption key={size} value={size.toString()}>
              {size}
            </McOption>
          ))}
        </McSelect>
      </div>
      <McPagination
        totalpages={Math.ceil(totalItems / pageSize)}
        currentpage={currentPage}
        previouslabel={narrowPagination ? "" : "Previous"}
        nextlabel={narrowPagination ? "" : "Next"}
        visiblepages={narrowPagination ? 3 : 5}
        pagechange={(e: any) => {
          if (e.detail !== currentPage) {
            onPageChange(e.detail);
          }
        }}
      />
    </div>
  );
};

export default PaginationControl;
